import simpleGit, { SimpleGit } from 'simple-git';

export { ConfigManager } from './config';
export type { RepoConfig } from './config';
export { MultiRepoMerge } from './multiRepoMerge';

export class GitMergeTools {
  private git: SimpleGit;

  constructor(workingDir: string) {
    this.git = simpleGit(workingDir);
  }

  /**
   * 合并源分支到目标分支
   * @param source 源分支名
   * @param target 目标分支名
   */
  async mergeBranch(source: string, target: string): Promise<void> {
    try {
      await this.git.checkout(target);
      await this.git.merge([source]);
    } catch (error: any) {
      throw new Error(`合并分支失败: ${error.message}`);
    }
  }

  /**
   * 中止当前的合并操作
   */
  async abortMerge(): Promise<void> {
    try {
      await this.git.merge(['--abort']);
    } catch (error: any) {
      throw new Error(`中止合并失败: ${error.message}`);
    }
  }

  /**
   * 使用指定策略解决冲突
   * @param strategy 解决策略：'ours' 使用我们的更改，'theirs' 使用他们的更改
   */
  async resolveConflicts(strategy: 'ours' | 'theirs'): Promise<void> {
    try {
      if (strategy === 'ours') {
        await this.git.checkout(['--ours', '.']);
      } else {
        await this.git.checkout(['--theirs', '.']);
      }
      await this.git.add('.');
    } catch (error: any) {
      throw new Error(`解决冲突失败: ${error.message}`);
    }
  }

  /**
   * 获取合并状态
   * @returns 是否处于合并状态
   */
  async isMerging(): Promise<boolean> {
    try {
      const status = await this.git.status();
      return status.conflicted.length > 0;
    } catch (error: any) {
      throw new Error(`获取合并状态失败: ${error.message}`);
    }
  }
}
